import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Select from "react-select";
import { all_routes } from "../../Router/all_routes";
import { DatePicker } from "antd";
import Addunits from "../../core/modals/inventory/addunits";
import AddCategory from "../../core/modals/inventory/addcategory";
import AddBrand from "../../core/modals/addbrand";
import dayjs from 'dayjs';
import {
  ArrowLeft,
  Calendar,
  Image,
  Info,
  LifeBuoy,
  List,
  Plus,
  PlusCircle,
  X,
} from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import * as Yup from 'yup';
import {
  useGetNewProductIdQuery, useGetStoreListQuery, useCreateProductMutation,
  useUpdateProductMutation, useGetProductDetailByIdQuery,
  useGetBrandListQuery,
  useGetUnitListQuery
} from "../../core/redux/api/productApi";
import { useGetCategoryListQuery } from "../../core/redux/api/categoryApi";
import PropTypes from 'prop-types';
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
import AddCategoryModal from "./add-category-modal";
import toast from "react-hot-toast";

const initialFormState = {
  saleRate: 0,
  purchaseRate: 0,
  productId: '',
  sku: '',
  store: '',
  warehouse: '',
  productName: '',
  hsnCode: '',
  counter: '',
  category: '',
  subCategory: '',
  // brand: null,
  unit: '',
  thumbnail: null,
  Image: null,
  description: '',
  gstType: false,
  gstRate: 0,
  discountType: '',
  discountValue: 0,
  quantityAlert: 0,
  fastMoving: false,
  warranty: '',
  manufacturer: '',
  manufacturedDate: null,
  expiryDate: null,
};

const validationSchema = Yup.object().shape({
  productName: Yup.string().required('Product Name is required'),
  productId: Yup.string().required('Product ID is required'),
  category: Yup.string().required('Category is required'),
  unit: Yup.string().required('Unit is required'),
  // All other fields are optional
});

const ProductForm = ({ isEditMode }) => {
  const [imageFile, setImageFile] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const { _id:productObjectId } = useParams();
  const navigate = useNavigate();

  // API hooks
  const { data: stores } = useGetStoreListQuery();
  // const { data: brand } = useGetBrandListQuery();
  const { data: unit } = useGetUnitListQuery();
  const { data: category, refetch: categoryRefetch } = useGetCategoryListQuery();
  const { data: existingProduct, isLoading: isProductLoading } = useGetProductDetailByIdQuery(productObjectId, { skip: !isEditMode });
  const { data: ProductIdData, refetch: refetchProductId } = useGetNewProductIdQuery();
  const [createProduct] = useCreateProductMutation();
  const [updateProduct] = useUpdateProductMutation();

  const [selectedImage, setSelectedImage] = useState(null);
  const [tags, setTags] = useState(["Red", "Black"]);
  const [product, setProduct] = useState(false);
  const [product2, setProduct2] = useState(true);

  // Generate options for selects
  const categoryOptions = category?.map(cat => ({
    value: cat?._id,
    label: cat?.name,
    subCategories: cat?.subCategory
  })) || [];

  // const brandOptions = brand?.data?.map(item => ({
  //   value: item?._id,
  //   label: item?.brandName
  // })) || [];

  const unitOptions = unit?.map(item => ({
    value: item?._id,
    label: item?.unitName
  })) || [];



  const handleCategoryChange = (selectedOption, setFieldValue) => {
    const newCategoryValue = selectedOption?.value || null;
    setSelectedCategory(newCategoryValue);
    setFieldValue('category', newCategoryValue || '');
    setFieldValue('subCategory', '');

    // Update subcategory options
    const newSubcategories = (selectedOption?.subCategories || []).map(subcat => ({
      value: subcat._id || subcat,
      label: subcat.name || subcat
    }));

    setSubCategoryOptions(newSubcategories);
  };

  const handleGenerateProductID = async (setFieldValue) => {
    try {
      const { data } = await refetchProductId();
      if (data?.productId || data?.code) {
        setFieldValue('productId', data.productId || data.code);
      }
    } catch (error) {
      console.error("Generation Error:", error);
    }
  };

  const handleImageChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    if (file && (file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg")) {
      if (file.size <= 2 * 1024 * 1024) {
        const imageUrl = URL.createObjectURL(file);
        setSelectedImage(imageUrl);
        setImageFile(file);
        console.log("Selected image file:", file);
        setFieldValue('Image', file);

      } else {
        toast.error("File must be less than 2MB.");
      }
    } else {
      toast.error("Only JPG and PNG files are allowed.");
    }
  };

  // const handleSubmit = async (values, { setSubmitting }) => {
  //   const formDataToSend = new FormData();

  //   // Prepare values for submission
  //   const processedValues = {
  //     ...values,
  //     // Convert dayjs to ISO string
  //     manufacturedDate: values.manufacturedDate ? values.manufacturedDate.toISOString() : null,
  //     expiryDate: values.expiryDate ? values.expiryDate.toISOString() : null,
  //     // Only send brand/unit/category as IDs
  //     // brand: values.brand || '',
  //     unit: values.unit || '',
  //     category: values.category || '',
  //   };

  //   Object.keys(processedValues).forEach(key => {
  //     if (
  //       processedValues[key] !== null &&
  //       processedValues[key] !== undefined &&
  //       processedValues[key] !== ''
  //     ) {
  //       formDataToSend.append(key, processedValues[key]);
  //     }
  //   });

  //   // Append image file if it exists
  //  if (imageFile) {
  //   formDataToSend.append('Image', imageFile);
  // } else if (isEditMode && !imageFile && existingProduct?.thumbnail) {
  //   // In edit mode, if no new image is selected but there's an existing one
  //   formDataToSend.append('thumbnail', existingProduct.thumbnail);
  // }

  //   try {
  //     if (isEditMode) {
  //       // Most common RTK Query pattern: pass id and body/formData
  //       await updateProduct({ _id: productObjectId, ...processedValues }).unwrap();
  //       navigate('/product-list');
  //     } else {
  //       await createProduct(formDataToSend).unwrap();
  //       alert("Product created successfully!");
  //       // navigate('/product-list');
  //     }
  //   } catch (error) {
  //     console.error('API Error:', error);
  //     alert(error.data?.message || 'Failed to submit product');
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  // Helper to normalize product data for Formik initialValues
  const normalizeProduct = (product) => {
    return {
      ...initialFormState,
      ...product,
      // Handle brand/unit/category as string IDs for Select
      // brand: product.brand && typeof product.brand === 'object' ? product?.brand._id : (product?.brand || null),
      unit: product.unit && typeof product.unit === 'object' ? product.unit._id : (product.unit || ''),
      category: product.category && typeof product.category === 'object' ? product.category._id : (product.category || ''),
      // Handle expiryDate and manufacturedDate as dayjs objects
      expiryDate: product.expiryDate
        ? dayjs(product.expiryDate)
        : (product.expiry ? dayjs(product.expiry) : null),
      manufacturedDate: product.manufacturedDate ? dayjs(product.manufacturedDate) : null,
      // Subcategory as string
      subCategory: product.subCategory && typeof product.subCategory === 'object'
        ? product.subCategory._id
        : (product.subCategory || ''),
    };
  };

  // Set initial values when in edit mode
  useEffect(() => {
    if (isEditMode && existingProduct) {
      setSelectedImage(existingProduct.thumbnail || null);

      // If there's a category, set the subcategory options
      if (existingProduct.category) {
        const cat = category?.find(c => c._id === existingProduct.category);
        if (cat) {
          const subs = (cat.subCategories || []).map(subcat => ({
            value: subcat._id || subcat,
            label: subcat.name || subcat
          }));
          setSubCategoryOptions(subs);
        }
      }
    }
  }, [isEditMode, existingProduct, category]);

  if (isEditMode && isProductLoading) return <div>Loading product data...</div>;

  return (
    <div>
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{isEditMode ? 'Edit' : 'Create'} Product</h4>
              <h6>{isEditMode ? 'Edit' : 'Create new'} product</h6>
            </div>
          </div>
          <ul className="table-top-head">

            <RefreshIcon />
            <CollapesIcon />
            <li>
              <div className="page-btn">
                <Link to={all_routes.productlist} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to Product
                </Link>
              </div>
            </li>
          </ul>
        </div>

        <Formik
          initialValues={ isEditMode && existingProduct ? normalizeProduct(existingProduct) : initialFormState}
          validationSchema={validationSchema}
       onSubmit={async (values, { setSubmitting }) => {
  const formDataToSend = new FormData();

  // Process values (dates, etc.)
  const processedValues = {
    ...values,
    manufacturedDate: values.manufacturedDate?.toISOString(),
    expiryDate: values.expiryDate?.toISOString(),
    unit: values.unit || '',
    category: values.category || '',
  };

  // Append all non-image values
  Object.entries(processedValues).forEach(([key, value]) => {
    if (value != null && value !== '' && key !== 'Image') {
      formDataToSend.append(key, value);
    }
  });

  // Append image only once
  if (imageFile) {
    formDataToSend.append('Image', imageFile);
  } else if (isEditMode && existingProduct?.thumbnail) {
    formDataToSend.append('Image', existingProduct.thumbnail);
  }

  // Debug log
  for (let pair of formDataToSend.entries()) {
    console.log(pair[0], pair[1]);
  }

  try {
    if (isEditMode) {
      await updateProduct({ _id: productObjectId, body: formDataToSend }).unwrap();
        // alert("Product Updated successfully!");
        toast.success("Product Updated successfully!");
    } else {
      await createProduct(formDataToSend).unwrap();
      // alert("Product created successfully!");
      toast.success("Product created successfully!");

    }
    navigate('/product-list');
  } catch (error) {
    // console.error('API Error:', error);
    toast.error(error.data?.message || 'Failed to submit product');
    
  } finally {
    setSubmitting(false);
  }
}}
          // enableReinitialize
        >
          {({ values, errors, touched, setFieldValue, isSubmitting }) => (
            <Form className="add-product-form">
              <div className="add-product">
                <div className="accordions-items-seperate" id="accordionSpacingExample">
                  {/* Product Information Section */}
                  <div className="accordion-item border mb-4">
                    <h2 className="accordion-header" id="headingSpacingOne">
                      <div className="accordion-button collapsed bg-white" data-bs-toggle="collapse" data-bs-target="#SpacingOne">
                        <div className="d-flex align-items-center justify-content-between flex-fill">
                          <h5 className="d-flex align-items-center">
                            <Info className="text-primary me-2" />
                            <span>Product Information</span>
                          </h5>
                        </div>
                      </div>
                    </h2>
                    <div id="SpacingOne" className="accordion-collapse collapse show" aria-labelledby="headingSpacingOne">
                      <div className="accordion-body border-top">
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                Product Name<span className="text-danger ms-1">*</span>
                              </label>
                              <Field
                                type="text"
                                name="productName"
                                className={`form-control ${errors.productName && touched.productName ? 'is-invalid' : ''}`}
                              />
                              <ErrorMessage name="productName" component="div" className="invalid-feedback" />
                            </div>
                          </div>
                          {/* <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                HSN Code
                              </label>
                              <Field type="number" name="hsnCode" className="form-control" />
                            </div>
                          </div> */}
                        </div>
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="mb-3 list position-relative">
                              <label className="form-label">
                                ProductId<span className="text-danger ms-1">*</span>
                              </label>
                              <Field
                                type="text"
                                name="productId"
                                className={`form-control list ${errors.productId && touched.productId ? 'is-invalid' : ''}`}
                                readOnly
                              />
                              <button
                                type="button"
                                className="btn btn-primaryadd"
                                onClick={() => handleGenerateProductID(setFieldValue)}
                                disabled={!!values.productId}
                              >
                                Generate
                              </button>
                              <ErrorMessage name="productId" component="div" className="invalid-feedback" />
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                SKU
                              </label>
                              <Field type="text" name="sku" className="form-control" />
                            </div>
                          </div>
                        </div>
                        <div className="addservice-info">
                          <div className="row">
                            <div className="col-sm-6 col-12">
                              <div className="mb-3">
                                <div className="add-newplus">
                                  <label className="form-label">
                                    Category<span className="text-danger ms-1">*</span>
                                  </label>
                                  <Link to="#" data-bs-toggle="modal" data-bs-target="#add-category">
                                    <PlusCircle className="plus-down-add" />
                                    <span>Add New Category</span>
                                  </Link>
                                </div>
                                <Select
                                  classNamePrefix="react-select"
                                  options={categoryOptions}
                                  placeholder="Choose Category"
                                  value={categoryOptions.find(opt => opt.value === values.category)}
                                  onChange={(option) => handleCategoryChange(option, setFieldValue)}
                                  // isDisabled={isEditMode}
                                  isClearable
                                  name="category"
                                />
                                {errors.category && touched.category && (
                                  <div className="invalid-feedback d-block">Category is required</div>
                                )}
                              </div>
                            </div>
                            {/* <div className="col-sm-6 col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Sub Category
                                </label>
                                <Select
                                  classNamePrefix="react-select"
                                  options={subCategoryOptions}
                                  placeholder={selectedCategory ? "Choose subCategory" : "Select category first"}
                                  isDisabled={!selectedCategory}
                                  value={subCategoryOptions.find(opt => opt.value === values.subCategory)}
                                  onChange={(option) => setFieldValue('subCategory', option?.value || '')}
                                  isClearable
                                  name="subCategory"
                                />
                              </div>
                            </div> */}
                          </div>
                        </div>
                        <div className="add-product-new">
                          <div className="row">
                         
                            <div className="col-lg-6 col-sm-8 col-12">
                              <div className="mb-3">
                                <div className="add-newplus">
                                  <label className="form-label">
                                    Unit<span className="text-danger ms-1">*</span>
                                  </label>
                                  <Link to="#" data-bs-toggle="modal" data-bs-target="#add-unit">
                                    <PlusCircle className="plus-down-add" />
                                    <span>Add New Unit</span>
                                  </Link>
                                </div>
                                <Select
                                  classNamePrefix="react-select"
                                  options={unitOptions}
                                  placeholder="Choose"
                                  value={unitOptions.find(opt => opt.value === values.unit)}
                                  onChange={(option) => setFieldValue('unit', option?.value || '')}
                                  isClearable
                                  name="unit"
                                />
                                {errors.unit && touched.unit && (
                                  <div className="invalid-feedback d-block">Unit is required</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="summer-description-box">
                            <label className="form-label">Description</label>
                            <Field
                              as="textarea"
                              name="description"
                              className="form-control"
                              rows="4"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Pricing & Stocks Section */}
                  <div className="accordion-item border mb-4">
                    <h2 className="accordion-header" id="headingSpacingTwo">
                      <div className="accordion-button collapsed bg-white" data-bs-toggle="collapse" data-bs-target="#SpacingTwo">
                        <div className="d-flex align-items-center justify-content-between flex-fill">
                          <h5 className="d-flex align-items-center">
                            <LifeBuoy className="text-primary me-2" />
                            <span>Pricing &amp; Stocks</span>
                          </h5>
                        </div>
                      </div>
                    </h2>
                    <div id="SpacingTwo" className="accordion-collapse collapse show" aria-labelledby="headingSpacingTwo">
                      <div className="accordion-body border-top">
                        <div className="tab-content">
                          <div className="tab-pane fade show active">
                            <div className="single-product">
                              <div className="row">
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Purchase Rate
                                    </label>
                                    <Field
                                      type="number"
                                      name="purchaseRate"
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Sale Rate
                                    </label>
                                    <Field
                                      type="number"
                                      name="saleRate"
                                      className="form-control"
                                      placeholder="enter selling rate of the product"
                                    />
                                  </div>
                                </div>
                              
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Quantity Alert
                                    </label>
                                    <Field
                                      type="number"
                                      name="quantityAlert"
                                      className="form-control"
                                      placeholder="enter the quantity after which you want alert"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Images Section */}
                  <div className="accordion-item border mb-4">
                    <h2 className="accordion-header" id="headingSpacingThree">
                      <div className="accordion-button collapsed bg-white" data-bs-toggle="collapse" data-bs-target="#SpacingThree">
                        <div className="d-flex align-items-center justify-content-between flex-fill">
                          <h5 className="d-flex align-items-center">
                            <Image className="text-primary me-2" />
                            <span>Images</span>
                          </h5>
                        </div>
                      </div>
                    </h2>
                    <div id="SpacingThree" className="accordion-collapse collapse show" aria-labelledby="headingSpacingThree">
                      <div className="accordion-body border-top">
                        <div className="col-lg-12">
                          <div className="add-choosen">
                            <div className="mb-3">
                              <div className="image-upload">
                                <input
                                  type="file"
                                  accept="image/png, image/jpeg"
                                  onChange={(e) => handleImageChange(e, setFieldValue)}
                                />
                                
                                <div className="image-uploads">
                                  <PlusCircle className="plus-down-add me-0" />
                                  <h4>Add Images</h4>
                                </div>
                              </div>
                            </div>

                            {selectedImage && (
                              <div className="phone-img">
                                <img
                                  src={typeof selectedImage === 'string' ? selectedImage : URL.createObjectURL(selectedImage)}
                                  alt="Preview"
                                  className="object-fit-cover h-100 rounded-1"
                                  width="100"
                                  height="50"
                                />
                                <Link to="#">
                                  <X
                                    className="x-square-add remove-product"
                                    onClick={() => {
                                      setSelectedImage(null);
                                      setImageFile(null);
                                      setFieldValue('Image', null);
                                    }}
                                  />
                                </Link>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

           
                </div>
              </div>
              <div className="col-lg-12">
                <div className="d-flex align-items-center justify-content-end mb-4">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => navigate(all_routes.productlist)}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-1"></span>
                        {isEditMode ? 'Updating...' : 'Creating...'}
                      </>
                    ) : (
                      isEditMode ? 'Update Product' : 'Add Product'
                    )}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      {/* Modals */}
  
      </div>

      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0 text-gray-9">
          2014 - 2025 © AERO PACK RETAIL AUTOMATION SOLUTIONS. All Right Reserved
        </p>
        <p>
          Designed &amp; Developed by{" "}
          <Link to="#" className="text-primary">
            Aero Pack Pos
          </Link>
        </p>
      </div>


    </div>

    <Addunits onSubmit={(newUnit) => setFieldValue('unit', newUnit._id)} />
            <AddCategoryModal
        
        onSuccess={() => {
          setSelectedCategory(null);
          categoryRefetch();
        }}
      />

    </div>
  );
};

ProductForm.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
};

export default ProductForm;

